module.exports = "/_next/static/images/invest-duotone-5d49a89f913ad4e88841df8918cc0335.svg";